module.exports = __webpack_public_path__ + "img/a-back.09751185.png";